export default defineAppConfig({
	// This template's own CMS page renders no store landing pages (SU-28), so
	// links to them would 404
	storeFinder: {
		landingPageLinks: false
	}
});
